import { getModule } from 'vuex-module-decorators';

import { StoreSingleton } from '.';
import SubscriptionStore from './subscription.module';

export const subscriptionStore = getModule<SubscriptionStore>(SubscriptionStore, StoreSingleton.getInstance());
